module.exports = __webpack_public_path__ + "static/reid-hoffman-a5793b15ddfb89a85c1ad63185cda745.jpg";